/**
 * deployment-drawer.js
 */

import React from 'react';
import { 
  useRouteMatch,
  useHistory,
} from "react-router-dom";
import { paths } from 'utils/routing';
import { Types } from 'utils/constants';
import DeploymentIndex from './deployment-index';
import DeploymentMenu from '../menu';
import MenuDrawer from 'components/menu-drawer';



export default function DeploymentDrawer(props) {
  let history = useHistory();
  let basePath = useRouteMatch();
  const drawerBasePath = basePath.url + paths.deployment.base;


  // MENU ROUTES
  const menuRoutes = [{
    component: DeploymentMenu,
    path: [
      drawerBasePath + paths.deployment.pattern
    ]
  }];


  // CONTENT ROUTES
  const routes = [{
    component: DeploymentIndex,
    path: [
      drawerBasePath + paths.deployment.pattern
    ]
  }];


  const onCloseLocal = () => {
    history.push(basePath.url);
  }


  return (
    <>
      <MenuDrawer
        drawerPath={paths.deployment.base}
        basePath={basePath.url}
        menuRoutes={menuRoutes}
        desktopRoutes={routes}
        mobileRoutes={routes}
        onClose={onCloseLocal}
        title='DEPLOYMENT'
        recordGroupType={Types.RecordGroup.DEPLOYMENT}
      />
    </>
  );
}